import { useBlockProps, RichText } from '@wordpress/block-editor';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as solidIcons from '@fortawesome/free-solid-svg-icons';
import * as regularIcons from '@fortawesome/free-regular-svg-icons';
import * as brandIcons from '@fortawesome/free-brands-svg-icons';

export default function Save({ attributes }) {
    const {
        id,
        icon,
        faIconSize,
        faIconColor,
        isLinkable,
        url,
        openInNewTab,
        spanText
    } = attributes;

    const getFontAwesomeIcon = (iconName) => {
        const icon = solidIcons[iconName] || regularIcons[iconName] || brandIcons[iconName];
        return icon;
    };

    const blockProps = useBlockProps.save();

    return (
        <div {...blockProps}>
            {isLinkable ? (
                <a 
                    href={url} 
                    target={openInNewTab ? '_blank' : '_self'} 
                    rel="noopener"
                    className="fp-ip-inner"
                >
                      <div className='fp-ip-icon'>
                            <FontAwesomeIcon
                                icon={getFontAwesomeIcon(icon)}
                                fontSize={faIconSize}
                                color={faIconColor}
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    openIconPicker();
                                }}
                            />
                       </div>
                    <RichText.Content
                        tagName="span"
                        value={spanText}
                    />
                </a>
            ) : (
                <div className="fp-ip-inner">
                      <div className='fp-ip-icon'>
                            <FontAwesomeIcon
                                icon={getFontAwesomeIcon(icon)}
                                fontSize={faIconSize}
                                color={faIconColor}
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    openIconPicker();
                                }}
                            />
                        </div>
                    <RichText.Content
                        tagName="span"
                        value={spanText}
                    />
                </div>
            )}
        </div>
    );
}